import { AuthService } from "../../../service/auth-service";
import { BifrostService } from "../../../service/bifrost-service";

const sendOTP = (mobile) => () => {
    return new Promise((resolve, reject) => {
        BifrostService.sendOtp(mobile)
            .then(response => resolve(response))
            .catch(error => reject(error));
    });
};

const verifyOtp = (params) => () => {
    const otp = params?.otp;
    const mobileNumber = params?.phone_number;
    return new Promise((resolve, reject) => {
        BifrostService.verifyOtp(otp, mobileNumber)
            .then(response => resolve(response))
            .catch(error => reject(error));
    });
};

const login = (params) => () => {
    return new Promise((resolve, reject) => {
        AuthService.login(params)
            .then(response => resolve(response.data))
            .catch(error => reject(error));
    });
};

export {
    sendOTP,
    verifyOtp,
    login
};
